import { Icon } from '@components';
import { routes } from '@constants';
import { useNavigateWithOfflineMode, useScreenSize } from '@hooks';
import Noise from '@pngs/Noise5.png';
import Background from '@pngs/NotFoundPage/airplaneBackground.png';
import { Button, Flex, theme, Typography } from '@styles';
import { ReactComponent as LogoEN } from '@svgs/logo-outlined-en.svg';
import { ReactComponent as LogoUA } from '@svgs/logo-outlined-ua.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { notFoundPageLayoutByVariant } from './NotFoundPage.layoutProps';

const NotFoundPage = () => {
  const { i18n } = useTranslation();
  const { navigate } = useNavigateWithOfflineMode();
  const { device, isTabletLG, isTabletSM } = useScreenSize();
  const layout = notFoundPageLayoutByVariant[device || 'desktop'];

  const { language } = useSelector((state) => state.authSlice);

  const navigateMainPage = () => {
    navigate(routes.mainPage);
  };

  const LogoIcon = {
    en: LogoEN,
    ua: LogoUA,
  };

  return (
    <Flex
      backgroundImage={Noise}
      backgroundSize="contain"
      flexDirection="column"
      height="100%"
      position="absolute"
      width="100%"
    >
      <Flex
        backgroundImage={Background}
        backgroundPositionX="right"
        backgroundRepeat="no-repeat"
        backgroundSize="contain"
        flexDirection="column"
        height="100%"
        position="absolute"
        width="100%"
      >
        <Icon
          height={isTabletSM ? 69 : 131}
          ml={layout.px}
          SVG={LogoIcon[language || 'en']}
          width={isTabletSM ? 52 : 98}
        />
        <Flex
          flexDirection="column"
          gap={48}
          left="50%"
          position="absolute"
          top="50%"
          transform="translate(-50%, -50%)"
        >
          <Flex flexDirection={isTabletLG ? 'column' : 'row'}>
            <Typography
              color={theme.colors.schoolBusYellow[100]}
              mb={isTabletLG ? 10 : 0}
              textAlign={isTabletLG ? 'center' : 'left'}
              variant={isTabletSM ? 'BN-bold-s64-lh64' : 'BN-bold-s123-lh104'}
              whiteSpace="nowrap"
            >
              {i18n.t('NotFoundPage.titleYellow')}
              {!isTabletLG && <> -&nbsp;</>}
            </Typography>
            <Typography
              color={theme.colors.white[100]}
              textAlign={isTabletLG ? 'center' : 'left'}
              variant={isTabletSM ? 'BN-bold-s64-lh64' : 'BN-bold-s123-lh104'}
              whiteSpace="nowrap"
            >
              {i18n.t('NotFoundPage.titleWhite')}
            </Typography>
          </Flex>
          <Flex>
            <Button
              m="auto"
              onClick={navigateMainPage}
              px={47}
              py={22}
              variant="secondary"
            >
              <Typography variant="MS-semibold-s16-lh25">
                {i18n.t('NotFoundPage.GoToMainPage').toUpperCase()}
              </Typography>
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default NotFoundPage;
